module.exports = __webpack_public_path__ + "media/images/1 Pin-7d16f555420349a1847f993c9c8ad3b1.svg";